/**
 * @generated SignedSource<<ca1b57d5bf37ba3d1433b249bf1dda84>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PostVoteType = "DOWN" | "NONE" | "UP" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type commentFragment$data = {
  readonly __typename: string;
  readonly author: {
    readonly avatarFallback: string;
    readonly displayName: string | null | undefined;
    readonly id: string;
    readonly photo: {
      readonly signedUrl: string;
    } | null | undefined;
    readonly username: string | null | undefined;
  } | null | undefined;
  readonly childrenCount: number;
  readonly content: any | null | undefined;
  readonly createdAt: any;
  readonly id: string;
  readonly parent: {
    readonly id: string;
  } | null | undefined;
  readonly userVote: {
    readonly vote: PostVoteType;
  } | null | undefined;
  readonly votes: number;
  readonly " $fragmentType": "commentFragment";
};
export type commentFragment$key = {
  readonly " $data"?: commentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"commentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "commentFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avatarFallback",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageFile",
          "kind": "LinkedField",
          "name": "photo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "signedUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "parent",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CommentVote",
      "kind": "LinkedField",
      "name": "userVote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vote",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "childrenCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "CommentInterface",
  "abstractKey": "__isCommentInterface"
};
})();

(node as any).hash = "1b85c36bb62711bda4482a729434eea9";

export default node;
